import { cssRule } from 'typestyle';

cssRule('.tb-checkbox-indent', {
    paddingLeft: '21px',
});

cssRule('.tb-site-invite-disabled', {
    fontWeight: 'normal',
    fontStyle: 'italic',
});

